import React, {
	useCallback,
	useMemo,
	useState,
} from 'react';
import { FixtureTypes } from '@shared/utils/constants';
import BunkerGainLossModal from '@client/screens/cargos/components/BunkerGainLossModal/BunkerGainLossModal';

export type ValidBunkerModalTypes = typeof FixtureTypes.TC_IN | typeof FixtureTypes.TC_OUT;

export const useBunkerModal = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [type, setType] = useState<ValidBunkerModalTypes>();

	const close = useCallback(() => setIsOpen(false), [setIsOpen]);

	const open = useCallback((incomingModalType: ValidBunkerModalTypes) => {
		setType(incomingModalType);
		setIsOpen(true);
	}, [setIsOpen]);

	const modal = useMemo(() => {
		if (type == null) {
			return null;
		}

		return (
			<BunkerGainLossModal open={isOpen} close={close} type={type} />
		);
	}, [isOpen, close, type]);

	return {
		modal,
		open,
		close,
	};
};
